import { makeStyles, createStyles } from '@material-ui/core'

export const useChatStyles = makeStyles((theme) =>
  createStyles({
    formContainer: {
      width: '100%'
    },

    input: {
      flex: 1,
      marginRight: theme.spacing(1)
    },

    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(3),

      [theme.breakpoints.up('md')]: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        marginRight: theme.spacing(4)
      }
    },

    cardContent: {
      height: 600,
      overflow: 'auto'
    },

    message: {
      display: 'flex',

      '&:not(:last-child)': {
        marginBottom: theme.spacing(4)
      }
    },

    sendIcon: {
      cursor: 'pointer'
    },

    messageReverse: {
      flexDirection: 'row-reverse',

      '& $avatar': {
        marginRight: 0,
        marginLeft: theme.spacing(3),

        [theme.breakpoints.up('md')]: {
          marginLeft: theme.spacing(4)
        }
      }
    },

    messageCard: {
      maxWidth: 632,
      minWidth: 136
    },

    messageCardContent: {
      height: '100%'
    },

    chip: {
      marginTop: theme.spacing(4.5),
      marginBottom: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center'
    }
  })
)
